module.exports = __webpack_public_path__ + "static/media/RequestPayment2.ce00475e.png";